module.exports = __webpack_public_path__ + "img/features_scoreboost_mobile.263da3da.png";